// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: "http://localhost:3000/",
  apiUrl: "https://api.globalopticmali.site/",
  // apiUrl: "http://5.189.170.169:3000/",
  hmr: false,
  logo: "assets/images/logo/gom.png",
  env: "stag",
  univ_sigle: "GLOBAL OPTIC MALI",
  univ_name: "Global Optic Mali",
  _http: "http://",
  _asset_image: "assets/images/logo/gom.png",
  email: "",
  password: "",
};
